<template>
  <div v-if="loading" style="text-align: center;">
    cargando...
  </div>
  <div v-else>
    <table 
      border="0"
    >
      <tr 
        v-for="(item, index) of result"
        :key="index"
      >
        <td>
          {{item.source}}
        </td>
        <td width="10%" style="text-align:center">
          <v-icon>mdi-arrow-right-bold</v-icon>
        <td>
        <td>
          {{item.target}}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import api from '@/services/api'
export default {
  props: {
    shareData: {
      type: Object,
      required: true,
    },
  },
  data: () =>  ({
    loading: false,
    source: null,
    target: null,
    result: ``
  }),
  mounted() {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.source = await new Promise((resolve) => api.getAll ('dviewcontent', `v1/system/workspaces/${this.shareData.SourceWorkspaceID}/content-types`, 0, 1000, '')
          .then(response => {
            resolve(response)
          }))
        this.target = await new Promise((resolve) => api.getAll ('dviewcontent', `v1/system/workspaces/${this.shareData.TargetWorkspaceID}/content-types`, 0, 1000, '')
          .then(response => {
            resolve(response)
          }))
        this.result = this.shareData.SharedContents.map(item => {
          return { 
            source: `${this.source.filter(x => x.ID === item.SourceContentID).map(item => `${item.Name} (${item.Type}) ${item.Width}x${item.Height}`).shift()}`,
            target: `${this.target.filter(x => x.ID === item.TargetContentID).map(item => `${item.Name} (${item.Type}) ${item.Width}x${item.Height}`).shift()}`
          }
        })
      } catch (error) {
        console.log(error)
        alert(error)
        this.loading = false
      }
    },
  },
}
</script>

